export interface forceUpdateItem {
  documentId: string;
  type: string;
}
export const setForceUpdateLocalStorage = (key: string, value: forceUpdateItem) => {
  localStorage.setItem(key, JSON.stringify(value));
  window.dispatchEvent(
    new CustomEvent("force-update", {
      detail: { key, value },
    })
  );
};
